let contentIndex = 1000;

export function arcContents(contents: Array<any>, sectionType: string, className?: string): Array<any> {
    // Get contents for section and sort by display sequence.
    contents = (contents || []).filter(e => e.contentSectionType === sectionType).sort((a, b) => a.displaySequence - b.displaySequence);

    // Create global header for ATA.
    if (!contents.length && sectionType === "GlobalHeader") {
        className = "ata-header";
        contents.push({ content: `<a href="/ata"><img src="/images/ata-logo.png"></a>` });
    }

    // Create global footer for ATA.
    if (!contents.length && sectionType === "GlobalFooter") {
        className = "ata-footer container align";
        contents.push({ content: `© 2018- Alliant Insurance Services, Inc. All rights reserved. CA License No. 0C36861` });
    }

    // Add container className if it isn't there.
    const isGlobal = sectionType === "GlobalHeader" || sectionType === "GlobalFooter";
    const isContainer = (className || "").split(" ").indexOf("container") > -1;
    if (!isGlobal && !isContainer) className = (className || "") + " container";

    // Build content form items.
    return contents.map(obj => {
        const contentItem: any = {
            type: "none",
            itemId: "content" + (obj.programEnrollmentContentId || obj.programEnrollmentRatingGroupContentId || contentIndex++),
            label: obj.content.replace(/images\//g, "assets/images/").replace(/&nbsp;/g, ''),
            className: (className || "").replace("_register", "") + " arc-content"
        };
        if ((className || "").indexOf("_register") > -1) {
            contentItem.rules = {
                section: {
                    [`${contentItem.itemId}.visible`]: {
                        any: [
                            { compare: ["#section", "==", "landing"] },
                            { compare: ["#section", "==", "register"] }
                        ]
                    }
                }
            };
        }
        return contentItem;
    });
}
